var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "newsletter-signup" }, [
    _c(
      "div",
      { staticClass: "newsletter-signup__wrapper" },
      [
        _vm._t("header"),
        _vm._v(" "),
        _vm._t("text"),
        _vm._v(" "),
        _vm.status <= 0
          ? _c(
              "div",
              { staticClass: "newsletter-signup__fields" },
              [
                _c("input-field", {
                  attrs: {
                    "icon-type": "user",
                    name: _vm.translations.name_field,
                    error: _vm.validation.name,
                    value: _vm.form.name
                  },
                  on: {
                    input: function(val) {
                      return _vm.$set(_vm.form, "name", val)
                    }
                  }
                }),
                _vm._v(" "),
                _c("input-field", {
                  attrs: {
                    "icon-type": "email",
                    name: _vm.translations.email_field,
                    error: _vm.validation.email,
                    value: _vm.form.email
                  },
                  on: {
                    input: function(val) {
                      return _vm.$set(_vm.form, "email", val)
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "newsletter-signup__ebook" },
          [
            _c("div", { staticClass: "newsletter-signup__ebook__image" }),
            _vm._v(" "),
            _vm._t("ebook-text")
          ],
          2
        ),
        _vm._v(" "),
        _vm.status == 1
          ? _c("p", {
              staticClass: "mail-msg mail-msg--success",
              domProps: { textContent: _vm._s(_vm.translations.success_msg) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.status == -1
          ? _c("p", {
              staticClass: "mail-msg mail-msg--error",
              domProps: { textContent: _vm._s(_vm.translations.fail_msg) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.status <= 0
          ? _c("button", {
              staticClass: "btn newsletter-signup__btn",
              class: { loading: _vm.loading },
              attrs: { disabled: _vm.validationErrors },
              domProps: { textContent: _vm._s(_vm.translations.signup_btn) },
              on: { click: _vm.subscribe }
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcca9464", { render: render, staticRenderFns: staticRenderFns })
  }
}